<div [@fadeOutTrigger]="passwordPopupState" class="password-prompt">
  <h1>{{promptService.getSectionPasswordPrompt(sectionId)}}</h1>
  <!--  <h3>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore-->
  <!--    magna aliqua. Ut enim ad minim veniam</h3>-->
  <input placeholder="Answer" type="text" [(ngModel)]="guess" class="burton-input"
         [@shakeit]="this.states['passwordUnlockText']" (@shakeit.done)="shakeEnd('passwordUnlockText', $event)"/>
  <button (click)="tryGuess()" class="burton-button mt-1">Unlock</button>
</div>
<!-- Video Section-->
<h2 *ngIf="sectionPopupState != 'shown'" style="margin-top: 10px;">Tap the play button to start the video</h2>
<h6 style="text-align: center" *ngIf="sectionPopupState != 'shown'">Once you've watched the video you will be taken to
  the next stage.</h6>
<app-video-player *ngIf="sectionPopupState != 'shown'" (videoEnded)="videoEnded()" [src]="'https://storage.googleapis.com/twisted-media/section'+sectionId+'.mp4'"
                  #playerComponent></app-video-player>
<!-- End Video Section-->
<div [@fadeOutTrigger]="sectionPopupState" class="password-prompt">
  <div class="wand" (click)="openWandPopup()">
    <fa-icon [icon]="magic"></fa-icon>
  </div>

<!--  Prompts -->
  <h4 *ngIf="sectionId == 1" style="margin-top: 50px;">Your quest has begun, now follow the map</h4>
  <h4 *ngIf="sectionId == 2" style="margin-top: 50px;">Well done Dearhearts, keep going</h4>
  <h4 *ngIf="sectionId == 3" style="margin-top: 50px;">Keep looking for magic, it’s hiding in plain sight</h4>
  <h4 *ngIf="sectionId == 4" style="margin-top: 50px;">Bad things happen in the woods, don’t stray from the path</h4>
  <h4 *ngIf="sectionId == 5" style="margin-top: 50px;">Hurry now, you’re running out of time</h4>
  <h4 *ngIf="sectionId == 6" style="margin-top: 50px;">That’s the final piece, bring it to me</h4>


  <google-map height="80%"
              width="100%"
              [zoom]="zoom"
              [center]="nextLocation"
              [options]="options" [mapTypeId]="SATELLITE" #map>

    <map-marker [position]="center" [options]="currentLocationOptions"></map-marker>

    <map-polyline [path]="[center,nextLocation]" [options]="pathOptions"></map-polyline>
    <map-marker [position]="nextLocation"></map-marker>

    <div class="QR-button-popup" ><!-- [@fadeOutTrigger]="scanPopupState"> -->
      <button class="burton-button burton-button-QR" routerLink="/scanner">Scan code</button>
    </div>
  </google-map>

</div>

<div class="card-award" [@awardLetterTrigger]="letterAward">
  <h3>Magic found</h3>
  <b style="font-size: 43px">{{letterToAward}}</b>
</div>


<div class="popup-background" [@quickFadeIn]="wandPopupState" [class.popup-open]="wandPopupState === 'open'"
     [class.popup-closed]="wandPopupState === 'closed'"></div>
<!-- Wand popup -->
<div class="popup" [@quickFadeIn]="wandPopupState" [class.popup-open]="wandPopupState === 'open'"
     [class.popup-closed]="wandPopupState === 'closed'">
  <div class="popup-header">
    <div (click)="this.closeWandPopup()" style="position: absolute;right: 13px;top: 13px;">
      <fa-icon [icon]="close"></fa-icon>
    </div>
    <h1>Magic store</h1>
  </div>
  <div class="popup-body">

    <div class="word">
      <p *ngIf="hasLetter('E')">E</p>
      <p *ngIf="!hasLetter('E')">?</p>
    </div>

    <div class="word">
      <p *ngIf="hasLetter('L')">L</p>
      <p *ngIf="!hasLetter('L')">?</p>
    </div>
    <div class="word">
      <p *ngIf="hasLetter('A')">A</p>
      <p *ngIf="!hasLetter('A')">?</p>
    </div>
    <div class="word">
      <p *ngIf="hasLetter('O')">O</p>
      <p *ngIf="!hasLetter('O')">?</p>
    </div>
    <div class="word">
      <p *ngIf="hasLetter('N')">N</p>
      <p *ngIf="!hasLetter('N')">?</p>
    </div>


  </div>

</div>

